export function getEditContent (h, data, node) {
  let self = this
  return (
    <span class="ly-visible">
      <el-button
        size="mini"
        on-click={() => self.close(data, node)}
      >
        取消
      </el-button>
      <el-button
        size="mini"
        on-click={() => self.editMsg(data, node)}
      >
        确认
      </el-button>
    </span>
  )
}

export function getDefaultContent (h, data, node) {
  let self = this
  return (
    <div class="ly-visible">
      {
        self.is_superuser &&
        (<span>
          {
            <el-button
              size="mini"
              icon="el-icon-plus"
              class="add-btn"
              on-click={() => self.append(node, data)}
            >
              {node.level!=1 ? <i>增加下一级</i>:  <i>增加类型</i>}
            </el-button>
          }
          {node.level!=1 && <el-button
            size="mini"
            class="del-btn"
            icon="el-icon-close"
            on-click={() => self.remove(node, data)}
          >
              删除
          </el-button>
          }
          {  node.level!=1 && <el-button
              size="mini"
              icon="el-icon-edit"
              class="edit-btn"
              on-click={() => self.update(node, data)}
            >
              编辑
            </el-button>         
          }
        </span>)
      }
    </div>
  )
}
